import { connect } from "react-redux";
import ListIaAgentsComponent from "../../Components/IaAgent/ListIaAgentsComponent";
import { setIaAgents } from "../../Redux/Actions/IaAgentActions";

const mapStateToProps = (state) => ({
    ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
    st_IaAgents: state.reducer.IA_AGENTS,
    ROLES: state.reducer.ROLES,
    SCOPES: state.reducer.SCOPES,
    SCOPES_NAMES: state.reducer.SCOPES_NAMES,
});

const mapDispatchToProps = (dispatch) => ({
    setIaAgents: (IA_AGENTS) => dispatch(setIaAgents(IA_AGENTS)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ListIaAgentsComponent);
